// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var DateUtils = require("../../../../shared/src/DateUtils.bs.js");
var MathUtils = require("../../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var WebEnvVars = require("../../WebEnvVars.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_NewShift = require("../../types/WebTypes_NewShift.bs.js");
var CommonTypes_ShiftType = require("../../../../shared/src/types/CommonTypes_ShiftType.bs.js");
var FormalityCompat__Form = require("re-formality/src/FormalityCompat__Form.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Subtext = require("../../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var BrowserComponents_InfoCard = require("../../../../shared-browser/src/components/BrowserComponents_InfoCard.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_DressCode = require("../../../../shared/src/types/CommonTypes_Shift_DressCode.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_PostAShiftForm = require("../../components/WebComponents_PostAShiftForm.bs.js");
var FormalityCompat__PublicHelpers = require("re-formality/src/FormalityCompat__PublicHelpers.bs.js");
var CommonTypes_ShiftType_Accessory = require("../../../../shared/src/types/CommonTypes_ShiftType_Accessory.bs.js");
var CommonTypes_Shift_OnsiteManager = require("../../../../shared/src/types/CommonTypes_Shift_OnsiteManager.bs.js");
var CommonTypes_Shift_TipsPayoutType = require("../../../../shared/src/types/CommonTypes_Shift_TipsPayoutType.bs.js");
var WebComponents_ProfessionalShiftPreview = require("../../components/WebComponents_ProfessionalShiftPreview.bs.js");
var CommonTypes_Business_Location_ParkingCost = require("../../../../shared/src/types/business/CommonTypes_Business_Location_ParkingCost.bs.js");

var googleMapsToken = WebEnvVars.vars.googleMapsWebClientApiToken;

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexDirection(BrowserStyle.row),
          tl: {
            hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
            tl: /* [] */0
          }
        }
      }
    });

var subText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Grey */2,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.marginTop(BrowserStyle.rem(0.5)),
            tl: {
              hd: BrowserStyle.textAlign("center"),
              tl: /* [] */0
            }
          }
        }));

var leftContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems("center"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(60.0)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                    tl: /* [] */0
                  }
                }),
            tl: {
              hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.Spacing.xxLarge),
              tl: /* [] */0
            }
          }
        }
      }
    });

var rightContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* White */7,
            _0: /* Medium */1
          }),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.display("none"),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var submissionError = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, /* Medium */3, undefined)({
          hd: BrowserStyle.color({
                TAG: /* Red */5,
                _0: /* Medium */2
              }),
          tl: {
            hd: BrowserStyle.height(BrowserStyle.rem(1.0)),
            tl: {
              hd: BrowserStyle.marginTop(BrowserStyle.rem(3.5)),
              tl: /* [] */0
            }
          }
        }));

var Styles = {
  container: container,
  subText: subText,
  leftContent: leftContent,
  rightContent: rightContent,
  submissionError: submissionError
};

function getValidShift(timezone, param) {
  var match = param.basicInfo;
  if (match === undefined) {
    return ;
  }
  var dates = param.dates;
  if (dates === undefined) {
    return ;
  }
  var match$1 = param.details;
  if (match$1 === undefined) {
    return ;
  }
  var match$2 = param.location;
  if (match$2 === undefined) {
    return ;
  }
  var parkingInstructions = match$2.parkingInstructions;
  var parkingCost = match$2.parkingCost;
  var locationName = match$2.locationName;
  var geocode = match$2.geocode;
  var existingLocation = match$2.existingLocation;
  var address = match$2.address;
  var selectedManager = match$1.selectedManager;
  var onsiteManagerPhoneNumber = match$1.onsiteManagerPhoneNumber;
  var onsiteManagerLastName = match$1.onsiteManagerLastName;
  var onsiteManagerFirstName = match$1.onsiteManagerFirstName;
  var dressCode = match$1.dressCode;
  var copiedFrom = match$1.copiedFrom;
  var attire = match$1.attire;
  var accessories = match$1.accessories;
  var tipsPayoutType = match.tipsPayoutType;
  var shiftType = match.shiftType;
  var requestedWorkers = match.requestedWorkers;
  var numberOfWorkers = match.numberOfWorkers;
  var hourlyRate = match.hourlyRate;
  return Relude_Option.map((function (description) {
                return {
                        accessories: Curry._1(CommonTypes_ShiftType_Accessory.$$Set.toArray, accessories),
                        address: address,
                        attire: Relude_String.toNonWhitespace(attire),
                        copiedFrom: copiedFrom,
                        dates: WebTypes_NewShift.Dates.makeShiftDates(dates),
                        description: description,
                        dressCode: dressCode,
                        geocode: geocode,
                        hourlyRate: hourlyRate,
                        locationId: Relude_Option.map((function (param) {
                                return param.id;
                              }), existingLocation),
                        locationName: locationName,
                        numberOfWorkers: numberOfWorkers,
                        onsiteManagerFirstName: onsiteManagerFirstName,
                        onsiteManagerIsNew: Relude_Option.isNone(selectedManager),
                        onsiteManagerLastName: onsiteManagerLastName,
                        onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
                        parkingCost: parkingCost,
                        parkingInstructions: parkingInstructions,
                        requestedWorkers: requestedWorkers,
                        shiftType: shiftType,
                        timezone: timezone,
                        tipsPayoutType: tipsPayoutType
                      };
              }), Relude_String.toNonWhitespace(match$1.description));
}

var Form = {
  getValidShift: getValidShift,
  initialState: getValidShift,
  validators: /* [] */0
};

var FormContainer = FormalityCompat__Form.Make({
      validators: /* [] */0
    });

function WebContainers_PostAShift_ShiftConfirmation(Props) {
  var goBack = Props.goBack;
  var markupRateOpt = Props.markupRate;
  var newShift = Props.newShift;
  var postShifts = Props.postShifts;
  var setToMinimumShiftStep = Props.setToMinimumShiftStep;
  var timezone = Props.timezone;
  var markupRate = markupRateOpt !== undefined ? markupRateOpt : 0.4;
  var match = Curry._2(FormContainer.useForm, getValidShift(timezone, newShift), (function (state, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var partial_arg = Curry._1(Relude_IO.mapError, (function (param) {
                  if (param.message === "The minimum worker rate was not met") {
                    return /* BelowMinimumRate */1;
                  } else {
                    return /* ErrorPostingShift */2;
                  }
                }));
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold(notifyOnFailure, Relude_Globals.id, param);
                      }), Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(postShifts, partial_arg, param);
                          }), Relude_Option.fold(Relude_IO.$$throw(/* InvalidShift */0), Relude_IO.pure, state)));
        }));
  var submit = match.submit;
  var submitting = match.submitting;
  var status = match.status;
  var validShift = match.state;
  ReactIO.useHandledIOOnMount(undefined)(DomUtils.$$Window.scrollToTop);
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Option.fold(goBack, partial_arg$1, param);
        }), validShift);
  return Relude_Option.fold(null, (function (param) {
                var tipsPayoutType = param.tipsPayoutType;
                var shiftType = param.shiftType;
                var requestedWorkers = param.requestedWorkers;
                var parkingInstructions = param.parkingInstructions;
                var parkingCost = param.parkingCost;
                var onsiteManagerPhoneNumber = param.onsiteManagerPhoneNumber;
                var onsiteManagerLastName = param.onsiteManagerLastName;
                var onsiteManagerFirstName = param.onsiteManagerFirstName;
                var locationName = param.locationName;
                var hourlyRate = param.hourlyRate;
                var geocode = param.geocode;
                var dressCode = param.dressCode;
                var description = param.description;
                var dates = param.dates;
                var attire = param.attire;
                var address = param.address;
                var accessories = param.accessories;
                var tmp;
                tmp = typeof status === "number" || status.TAG !== /* SubmissionFailed */1 ? null : (
                    status._0 !== 1 ? React.createElement(BrowserComponents_Subtext.make, {
                            className: submissionError,
                            children: "Uh oh! Looks like something went wrong. Please try to refresh the page. If you continue to see this error, please reach out to support."
                          }) : React.createElement(BrowserComponents_Subtext.make, {
                            className: submissionError,
                            children: "The rate for this shift does not meet the rate required for high quality Professionals at this time"
                          })
                  );
                return React.createElement("form", {
                            className: container,
                            onSubmit: (function (param) {
                                return FormalityCompat__PublicHelpers.Dom.preventDefault(submit, param);
                              })
                          }, React.createElement(BrowserComponents_FlexColumn.make, {
                                className: leftContent,
                                children: null
                              }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                                    subtitle: "Just checking we got everything right.",
                                    title: "Confirmation"
                                  }), React.createElement(BrowserComponents_FlexRow.make, {
                                    children: null
                                  }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                                        title: "Shift Information"
                                      }), React.createElement(BrowserComponents_Button.Icon.make, {
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: {
                                            TAG: /* Shift */6,
                                            _0: /* PencilEdit */16
                                          }
                                        },
                                        iconColor: {
                                          TAG: /* Teal */6,
                                          _0: /* Medium */2
                                        },
                                        onClick: (function (param) {
                                            return Curry._1(setToMinimumShiftStep, /* BasicInfo */2);
                                          })
                                      })), React.createElement(BrowserComponents_InfoCard.make, {
                                    info: Relude_Array.concat(Relude_Set.isEmpty(requestedWorkers) ? [] : [{
                                              title: "Requested Professionals",
                                              content: Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                                                      return prim + prim$1;
                                                    }), "", Relude_Array.intersperse(", ", Curry._2(Relude_Array.map, (function (param) {
                                                              return param.fullName;
                                                            }), Relude_Set.toArray(requestedWorkers))))
                                            }], [
                                          {
                                            title: "Shift Type",
                                            content: CommonTypes_ShiftType.toString(shiftType)
                                          },
                                          {
                                            title: "Professionals",
                                            content: Relude_Int.toString(param.numberOfWorkers)
                                          },
                                          {
                                            title: "Tips Earned",
                                            content: CommonTypes_Shift_TipsPayoutType.toDisplayString(tipsPayoutType)
                                          },
                                          {
                                            title: "Hourly Rate",
                                            content: MathUtils.formatMoney(hourlyRate)
                                          },
                                          {
                                            title: "Qwick Service Fee",
                                            content: MathUtils.formatMoney(hourlyRate * markupRate)
                                          },
                                          {
                                            title: "Total Hourly Rate",
                                            content: MathUtils.formatMoney(hourlyRate * markupRate + hourlyRate)
                                          },
                                          {
                                            title: "Attire",
                                            content: Relude_Option.getOrElse("Custom", CommonTypes_Shift_DressCode.getDescription(dressCode))
                                          },
                                          {
                                            title: "Special Instructions",
                                            content: Relude_Option.getOrElse("", attire)
                                          },
                                          {
                                            title: "Accessories",
                                            content: Curry._2(Relude_Array.map, (function (accessory) {
                                                      return accessory.name;
                                                    }), accessories).join(", ")
                                          },
                                          {
                                            title: "Manager Name",
                                            content: onsiteManagerFirstName + (" " + onsiteManagerLastName)
                                          },
                                          {
                                            title: "Manager Contact",
                                            content: CommonTypes_LongPhoneNumber.toFormattedString(onsiteManagerPhoneNumber)
                                          },
                                          {
                                            title: "Description",
                                            content: description
                                          }
                                        ])
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XXLarge */7
                                  }), React.createElement(BrowserComponents_FlexRow.make, {
                                    children: null
                                  }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                                        title: "Location"
                                      }), React.createElement(BrowserComponents_Button.Icon.make, {
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: {
                                            TAG: /* Shift */6,
                                            _0: /* PencilEdit */16
                                          }
                                        },
                                        iconColor: {
                                          TAG: /* Teal */6,
                                          _0: /* Medium */2
                                        },
                                        onClick: (function (param) {
                                            return Curry._1(setToMinimumShiftStep, /* Location */0);
                                          })
                                      })), React.createElement(BrowserComponents_InfoCard.make, {
                                    info: [
                                      {
                                        title: "Location Name",
                                        content: locationName
                                      },
                                      {
                                        title: "Address",
                                        content: address
                                      },
                                      {
                                        title: "Parking Cost",
                                        content: CommonTypes_Business_Location_ParkingCost.toDisplayString(parkingCost)
                                      },
                                      {
                                        title: "Arrival Instructions",
                                        content: parkingInstructions
                                      }
                                    ]
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XXLarge */7
                                  }), React.createElement(BrowserComponents_FlexRow.make, {
                                    children: null
                                  }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                                        title: "Date & Time"
                                      }), React.createElement(BrowserComponents_Button.Icon.make, {
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: {
                                            TAG: /* Shift */6,
                                            _0: /* PencilEdit */16
                                          }
                                        },
                                        iconColor: {
                                          TAG: /* Teal */6,
                                          _0: /* Medium */2
                                        },
                                        onClick: (function (param) {
                                            return Curry._1(setToMinimumShiftStep, /* DateTime */1);
                                          })
                                      })), React.createElement(BrowserComponents_InfoCard.make, {
                                    info: [
                                      {
                                        title: "Date",
                                        content: Curry._2(Relude_Array.map, (function (param) {
                                                  return DateUtils.formatDate(/* LongDate */10, /* Zone */{
                                                                _0: timezone
                                                              })(param.startDatetime);
                                                }), dates).join(" \n")
                                      },
                                      {
                                        title: "Time",
                                        content: Relude_Option.fold("-", (function (param) {
                                                return DateUtils.formatDate(/* Time */14, /* Zone */{
                                                              _0: timezone
                                                            })(param.startDatetime) + ("-" + DateUtils.formatDate(/* Time */14, /* Zone */{
                                                                _0: timezone
                                                              })(param.endDatetime));
                                              }), Relude_Array.head(dates))
                                      }
                                    ]
                                  }), tmp, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XLarge */6
                                  }), React.createElement(WebComponents_PostAShiftForm.Buttons.make, {
                                    onBackButtonClick: goBack,
                                    submitButtonDisabled: submitting,
                                    submitButtonTitle: "Post Shift"
                                  })), Relude_Option.fold(null, (function (param) {
                                  return React.createElement(WebComponents_ProfessionalShiftPreview.make, {
                                              accessories: accessories,
                                              address: address,
                                              attire: attire,
                                              className: rightContent,
                                              description: description,
                                              dressCode: dressCode,
                                              endDatetime: param.endDatetime,
                                              geocode: geocode,
                                              googleMapsToken: googleMapsToken,
                                              hourlyRateCents: Relude_Float.floorAsInt(hourlyRate * 100.0),
                                              locationName: locationName,
                                              onsiteManager: CommonTypes_Shift_OnsiteManager.make(onsiteManagerFirstName + (" " + onsiteManagerLastName), onsiteManagerPhoneNumber),
                                              parkingCost: parkingCost,
                                              parkingInstructions: parkingInstructions,
                                              shiftType: shiftType,
                                              startDatetime: param.startDatetime,
                                              timezone: timezone,
                                              tipsPayoutType: tipsPayoutType
                                            });
                                }), Relude_Array.head(dates)));
              }), validShift);
}

var make = WebContainers_PostAShift_ShiftConfirmation;

exports.googleMapsToken = googleMapsToken;
exports.Styles = Styles;
exports.Form = Form;
exports.FormContainer = FormContainer;
exports.make = make;
/* container Not a pure module */
